import { Box, CircularProgress, Grid } from '@mui/material'
import React, { useEffect, useCallback } from 'react'
import "./index.css"
import BannerPage from './banner';
import Products from './products';
import VoucherCarousel from '../evouchers/VoucherCarousel';
import secureLocalStorage from 'react-secure-storage';
import { HttpRequest } from '../HttpRequest';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

const HomePage = () => {
    const [isLoading, setIsLoading] = React.useState(true);
    const [vouchers, setVouchers] = React.useState([]);
    const { evoucherEnabled } = useSelector((store) => store.configs);
    const location = useLocation();

    // Determine if we should show the buy button based on current route
    const showBuyButton = location.pathname !== '/evouchers';

    const getVouchers = useCallback(() => {
        setIsLoading(true);
        let businessNumber = secureLocalStorage.getItem("businessId");
        HttpRequest({
            method: 'GET',
            url: `/api/v1/ecommerce/voucher_campaigns?businessNumber=${businessNumber}&limit=10&page=1&status=Active`
        }).then(async (data) => {
            const vouchersFound = data.response.data || [];
            // Filter only active vouchers that haven't expired
            const activeVouchers = vouchersFound.filter(voucher => {
                const endDate = new Date(voucher.endDate).getTime();
                const now = new Date().getTime();
                return endDate > now;
            });
            setVouchers(activeVouchers);
        }).catch((error) => {
            console.error('Error fetching vouchers:', error);
            setVouchers([]);
        }).finally(() => {
            setIsLoading(false);
        });
    }, []);

    useEffect(() => {
        if (evoucherEnabled) {
            getVouchers();
        } else {
            setIsLoading(false);
        }
    }, [evoucherEnabled, getVouchers]);

    return (
        <Grid container spacing={2}>
            {evoucherEnabled === true && (isLoading || vouchers?.length > 0) && (
                <Grid item xs={12}>
                    <VoucherCarousel vouchers={vouchers} showBuyButton={showBuyButton} isLoading={isLoading} />
                </Grid>
            )}

            <Grid item xs={12}>
                <Box sx={{ width: '100%', maxWidth: { xs: '350px', sm: '100%' } }}>
                    <BannerPage />
                </Box>
            </Grid>

            <Grid item xs={12}>
                <Box sx={{ width: '100%', maxWidth: { xs: '320px', sm: '700px', md: '100%' } }}>
                    <Products />
                </Box>
            </Grid>
        </Grid>
    )
}

export default HomePage